












































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import axios from 'axios';
import { mapState } from 'vuex';
import userService from '@/services/hub/user';
import AppHeaderGallery from '@/components/AppHeaderGallery.vue';
import { registerLog } from '@/services/hub/logsAction';
import jwtDecode from 'jwt-decode';
import { debounce } from 'lodash';

export default Vue.extend({
  name: 'VideoView',
  components: {
    AppHeaderGallery,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      planOdId: 0 as any,
      userToken: '',
      customerPlansId: 0,
      breadcrumb: [] as any,
      id_customer: 0,
      video: {
        id: '',
        name: '',
        description: '',
        fileUrl: '',
        thumbBaseUrl: '',
        hash: '',
        cover: '',
        storage_hash: '',
        parentId: '' as any,
        cdnUrl: '',
        filename: '',
        download_url: '',
        subtitles: [] as any,
        subtitle: '' as any,
      },
      oldVideo: {
        id: '',
        name: '',
        description: '',
        fileUrl: '',
        thumbBaseUrl: '',
        hash: '',
        cover: '',
        storage_hash: '',
        parentId: '' as any,
        cdnUrl: '',
        filename: '',
        download_url: '',
        subtitles: [] as any,
        subtitle: '' as any,
      },
      player: {
        sourceCode: '',
        width: '' as any,
        height: '' as any,
        type: { text: this.$t('fixed'), value: 'fixed' },
        subtitles: '' as any,
      },
      secretPlayer: '',
      playerTypes: [
        { text: 'Fixo', value: 'fixed' },
        { text: 'Porcentagem', value: 'percentage' },
        { text: 'Proporção 16/9', value: 'proportion' },
        { text: 'Proporção 4/3', value: 'proportion2' },
      ] as any,
      iframeKey: 0,
      iframeCode: '',
      coverSelect: '',
      videoUrl1: '',
      videoUrl2: '',
      videoUrl3: '',
      thumbnailFile: '' as any,
      thumbUpload: false,
      downloading: false,
      preparing: false,
      subtitleModal: false,
      subtitleDeleteModal: false,
      subtitleEditModal: false,
      selectedLanguage: null,
      subtitleFile: null,
      languages: [
        { text: 'English', value: 'en-US' },
        { text: 'Portuguese', value: 'pt-BR' },
        { text: 'Spanish', value: 'es-ES' },
      ],
      subtitleFields: [0],
      selectedLanguages: [],
      subtitleFiles: [],
      subtitleEntries: [{ language: null, file: null }],
      username: '',
      oldPlayerCustomization: {
        themeColor: '#000000' as any,
        allowKeyPassword: false,
        keyPassword: '0',
        privateVideo: false as boolean,
        video360: false as boolean,
        SEO: false,
        seoTags: [],
        progress: false,
        loadAfterPlay: false,
        sharing: false,
        whatsapp: false,
        linkedin: false,
        twitter: false,
        facebook: false,
        autoplay: false as any,
        audioNotificationColor: '#43007E',
        iconTextColor: '#FFFFFF',
        big_button: false as any,
      },
      playerCustomization: {
        themeColor: '#000000' as any,
        allowKeyPassword: false,
        keyPassword: '0',
        privateVideo: false as boolean,
        video360: false as boolean,
        SEO: false,
        seoTags: [],
        progress: false,
        loadAfterPlay: false,
        sharing: false,
        whatsapp: false,
        linkedin: false,
        twitter: false,
        facebook: false,
        autoplay: false as any,
        audioNotificationColor: '#43007E',
        iconTextColor: '#FFFFFF',
        big_button: false as any,
      },
      colorMenu: false,
      iconTextColorMenu: false,
      availableTags: [],
      deleteModalVisible: false,
      dialogTranscription: false,
      selectedLanguageTranscription: null,
      subtitleToDeleteIndex: null as any,
    };
  },
  computed: {
    translatedPlayerTypes(): any {
      return this.playerTypes.map((type: any) => ({
        ...type,
        text: this.$t(type.value),
      }));
    },
    translatedLanguages(): any {
      return this.languages.map((lang: any) => ({
        text: this.$t(lang.text),
        value: lang.value,
      }));
    },
    // eslint-disable-next-line vue/return-in-computed-property
    formattedSubtitles(): any {
      let subtitles;
      if (this.video.subtitle) {
        subtitles = typeof this.video.subtitle === 'string'
          ? JSON.parse(this.video.subtitle)
          : this.video.subtitle;
      }

      if (subtitles) {
        return subtitles.map((subtitle: any) => {
          let languageName;
          switch (subtitle.language) {
            case 'pt-BR':
              languageName = 'Português';
              break;
            case 'en-US':
              languageName = 'Inglês';
              break;
            default:
              languageName = subtitle.language;
          }
          return {
            ...subtitle,
            languageName,
          };
        });
      }
      return '';
    },
  },
  watch: {
    id: 'fetchFolder',
    'player.width': 'generateIframeCode',
    'player.height': 'generateIframeCode',
  },
  async mounted() {
    await this.userInformation();
  },
  methods: {
    async userInformation() {
      const userInfo = localStorage.getItem('user');
      if (userInfo) {
        const user = JSON.parse(userInfo);

        const { token } = user;
        const decodedToken = jwtDecode(token) as any;
        this.username = decodedToken.sub.nickname;
        this.id_customer = decodedToken.sub.id_customers;
        this.customerPlansId = user.user.plan_id;
        this.userToken = user.token;
        await this.getPlanOd(this.customerPlansId);
        await this.getGalleryVideos(this.planOdId);
        await this.getCustomerPlan(this.planOdId);
        await this.getBreadcrumb();
        this.player.width = 640;
        this.player.height = 360;
        this.iframeCode = `<iframe allow="0" allowfullscreen class="jmvplayer" frameborder="0" src="${this.video.fileUrl}" width="640" height="360"></iframe>`;
        await this.fetchPlayerInfo();
      }
    },
    debouncedUpdateVideoInfo: debounce(function (this: any) {
      this.updateVideoInfo();
    }, 300),
    showToast(key: string, type: string) {
      const text = this.$t(key);
      this.$store.dispatch('notification/create', {
        text,
        type,
      });
    },
    async logUserAction(action: string, status: string, description: string) {
      try {
        const logData = {
          id_customers: this.id_customer,
          username: this.username,
          action,
          status,
          description,
        };

        await registerLog(logData);
        console.log('Log registrado com sucesso!');
      } catch (error) {
        console.error('Erro ao registrar o log:', error);
      }
    },
    async getPlanOd(customerPlansId: number) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/event/getPlanOd/${customerPlansId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });
        this.planOdId = response.data.customerPlansOdId;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async getGalleryVideos(planId: number) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/galleries/videos/${planId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });

        // eslint-disable-next-line max-len
        const videoFilter = response.data.filter(
          (item: any) => Number(item.id) === Number(this.$route.params.id),
        );
        // eslint-disable-next-line prefer-destructuring
        this.video = videoFilter[0];
        // eslint-disable-next-line prefer-destructuring
        this.oldVideo = JSON.parse(JSON.stringify(videoFilter[0]));
        await this.thumbsUrl();
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    loadVideoUrl() {
      const env = process.env.VUE_APP_ENV || 'production';

      let baseUrl;
      if (env === 'sandbox') {
        baseUrl = 'https://player-sandbox.jmvstream.com/';
      } else if (env === 'staging') {
        baseUrl = 'https://player-staging.jmvstream.com/';
      } else {
        baseUrl = 'https://player.jmvstream.com/';
      }

      this.video.fileUrl = `${baseUrl}${this.secretPlayer}/${this.video.hash}`;
    },
    refreshIframe() {
      setTimeout(() => {
        this.iframeKey += 1;
      }, 1000);
    },
    sleep(ms: any) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async downloadVideo() {
      const env = process.env.VUE_APP_ENV || 'production';

      let baseUrl;
      if (env === 'sandbox') {
        baseUrl = 'https://cdn-sandbox.jmvstream.com/download/';
      } else if (env === 'staging') {
        baseUrl = 'https://cdn-staging.jmvstream.com/download/';
      } else {
        baseUrl = 'https://cdn.jmvstream.com/download/';
      }

      const downloadUrl = `${baseUrl}vod_${this.planOdId}/${this.video.filename}`;
      this.showToast('Preparing download...', 'info');
      this.preparing = true;
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/download/${this.video.hash}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });
        if (response.status === 200) {
          do {
            // eslint-disable-next-line no-undef, no-await-in-loop
            await this.getGalleryVideos(this.planOdId);

            if (!this.video.download_url) {
              // eslint-disable-next-line no-await-in-loop
              await this.sleep(5000);
            }
          } while (!this.video.download_url);
          this.downloading = true;
          this.preparing = false;
          this.showToast('Download Completed', 'success');
          window.open(downloadUrl, '_blank');
          await this.userInformation();
        }
      } catch (error) {
        console.error('Erro ao baixar vídeo:', error);
        this.showToast('Error downloading', 'error');
      } finally {
        this.downloading = false;
        this.preparing = false;
      }
    },
    formatVideoDuration(time: string) {
      const [hours, minutes, seconds] = time.split(':');
      return `${hours}:${minutes}:${seconds.split('.')[0]}`;
    },
    formatFileSize(size: any) {
      if (size === 0) return '0 B';

      const units = ['B', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(size) / Math.log(1024));
      // eslint-disable-next-line no-restricted-properties
      return `${Math.round((size / Math.pow(1024, i)) * 100) / 100} ${units[i]}`;
    },
    formatDate(dateTimeString: string): string {
      const date = new Date(dateTimeString);
      const formattedDate = date.toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
      return formattedDate;
    },
    async selectThumbnail(thumb: number) {
      if (thumb === 0) {
        this.video.cover = 'cover1.jpg';
      } else if (thumb === 1) {
        this.video.cover = 'cover2.jpg';
      } else if (thumb === 2) {
        this.video.cover = 'cover3.jpg';
      }
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        await axios.put(
          `${apiUrl}/updateVideo/${this.planOdId}/${this.video.id}`,
          {
            cover: this.video.cover,
            parentId: this.video.parentId,
          },
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );
        this.thumbUpload = false;
        const description = `Capa do video ${this.video.name}, com hash ${this.video.hash} foi alterada com sucesso.`;
        await this.logUserAction('Modification', 'Success', description);
        this.showToast('Cover successfully selected', 'success');
        this.refreshIframe();
      } catch (error) {
        const description = `Erro ao alterar capa do video ${this.video.name}, com hash ${this.video.hash}.`;
        await this.logUserAction('Modification', 'Error', description);
        console.error('Error saving video details:', error);
      }
      await this.thumbsUrl();
    },
    async saveVideoDetails() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        await axios.put(
          `${apiUrl}/updateVideo/${this.planOdId}/${this.video.id}`,
          {
            name: this.video.name,
            description: this.video.description,
            cover: this.video.cover,
            parentId: this.video.parentId,
          },
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );

        let logDescription = `Alterou informações do vídeo ${this.oldVideo.name} com hash: ${this.oldVideo.hash} `;

        if (this.oldVideo.name !== this.video.name) {
          logDescription = `Vídeo com o hash: ${this.video.hash} teve o nome alterado de "${this.oldVideo.name}" para "${this.video.name}". `;
        }
        if (this.oldVideo.description !== this.video.description) {
          logDescription = `Vídeo com o hash: ${this.video.hash} teve a descrição alterada de "${this.oldVideo.description}" para "${this.video.description}". `;
        }
        if (this.oldVideo.cover !== this.video.cover) {
          logDescription = `Vídeo com o hash: ${this.video.hash} teve a capa alterada de "${this.oldVideo.cover}" para "${this.video.cover}". `;
        }
        if (this.oldVideo.parentId !== this.video.parentId) {
          logDescription = `Vídeo com o hash: ${this.video.hash} teve a pasta alterada de "${this.oldVideo.parentId}" para "${this.video.parentId}". `;
        }

        if (this.oldPlayerCustomization.big_button !== this.playerCustomization.big_button) {
          // eslint-disable-next-line max-len
          if (
            this.playerCustomization.big_button === true
            || this.playerCustomization.big_button === 1
          ) {
            logDescription = `Vídeo com o hash: ${this.video.hash} teve o big button setado como true.`;
          } else {
            logDescription = `Vídeo com o hash: ${this.video.hash} teve o big button setado como false.`;
          }
        }

        await this.logUserAction('Modification', 'Success', logDescription);

        await this.updateVideoInfoNoToast();
        this.showToast('The information was saved successfully', 'success');
        this.refreshIframe();
      } catch (error) {
        let logDescription = `Erro ao alterar informações do vídeo ${this.oldVideo.name}`;

        if (this.oldVideo.name !== this.video.name) {
          logDescription = `Video com o hash: ${this.video.hash} obteve um erro ao tentar alterar o nome do vídeo de "${this.oldVideo}" para "${this.video.name}". `;
        }
        if (this.oldVideo.description !== this.video.description) {
          logDescription = `Video com o hash: ${this.video.hash} obteve um erro ao tentar alterar a descrição alterada de "${this.oldVideo.description}" para "${this.video.description}". `;
        }
        if (this.oldVideo.cover !== this.video.cover) {
          logDescription = `Video com o hash: ${this.video.hash} obteve um erro ao tentar alterar a capa alterada de "${this.oldVideo.cover}" para "${this.video.cover}". `;
        }
        if (this.oldVideo.parentId !== this.video.parentId) {
          logDescription = `Video com o hash: ${this.video.hash} obteve um erro ao tentar alterar a pasta alterada de "${this.oldVideo.parentId}" para "${this.video.parentId}". `;
        }
        await this.logUserAction('Modification', 'Error', logDescription);
        console.error('Error saving video details:', error);
      }
    },
    async updateVideoInfo() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        // Corrigir formato da cor do tema
        const themeColor = this.formatHexColor(this.playerCustomization.themeColor);
        const audioNotificationColor = this.formatHexColor(
          this.playerCustomization.audioNotificationColor,
        );
        const iconTextColor = this.formatHexColor(this.playerCustomization.iconTextColor);

        await axios.put(
          `${apiUrl}/updatePlayerInfo/${this.planOdId}/${this.video.id}`,
          {
            allow_video_iframe: this.playerCustomization.privateVideo,
            allow_key_password: this.playerCustomization.allowKeyPassword,
            key_password: this.playerCustomization.keyPassword,
            video_360: this.playerCustomization.video360,
            load_after_play: this.playerCustomization.loadAfterPlay,
            allow_seo: this.playerCustomization.SEO,
            tags: this.playerCustomization.seoTags,
            allow_progress: this.playerCustomization.progress,
            theme_color: themeColor,
            allow_sharing: this.playerCustomization.sharing,
            allow_sharing_whatsapp: this.playerCustomization.whatsapp,
            allow_sharing_facebook: this.playerCustomization.facebook,
            allow_sharing_linkedin: this.playerCustomization.linkedin,
            allow_sharing_twitter: this.playerCustomization.twitter,
            auto_play: this.playerCustomization.autoplay,
            audio_notification_color: audioNotificationColor,
            icon_text_color: iconTextColor,
            big_button: this.playerCustomization.big_button,
          },
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );
        let logDescription = `Alterou informações do vídeo ${this.oldVideo.name} com hash: ${this.oldVideo.hash} `;

        if (this.oldVideo.name !== this.video.name) {
          logDescription = `Vídeo com o hash: ${this.video.hash} teve o nome alterado de "${this.oldVideo.name}" para "${this.video.name}". `;
        }
        if (this.oldVideo.description !== this.video.description) {
          logDescription = `Vídeo com o hash: ${this.video.hash} teve a descrição alterada de "${this.oldVideo.description}" para "${this.video.description}". `;
        }
        if (this.oldVideo.cover !== this.video.cover) {
          logDescription = `Vídeo com o hash: ${this.video.hash} teve a capa alterada de "${this.oldVideo.cover}" para "${this.video.cover}". `;
        }
        if (this.oldVideo.parentId !== this.video.parentId) {
          logDescription = `Vídeo com o hash: ${this.video.hash} teve a pasta alterada de "${this.oldVideo.parentId}" para "${this.video.parentId}". `;
        }

        if (this.oldPlayerCustomization.autoplay !== this.playerCustomization.autoplay) {
          // eslint-disable-next-line max-len
          if (
            this.playerCustomization.autoplay === true
            || this.playerCustomization.autoplay === 1
          ) {
            logDescription = `Vídeo com o hash: ${this.video.hash} teve o auto play setado como true.`;
          } else {
            logDescription = `Vídeo com o hash: ${this.video.hash} teve o auto play setado como false.`;
          }
        }

        if (this.oldPlayerCustomization.big_button !== this.playerCustomization.big_button) {
          // eslint-disable-next-line max-len
          if (
            this.playerCustomization.big_button === true
            || this.playerCustomization.big_button === 1
          ) {
            logDescription = `Vídeo com o hash: ${this.video.hash} teve o big button setado como true.`;
          } else {
            logDescription = `Vídeo com o hash: ${this.video.hash} teve o big button setado como false.`;
          }
        }

        await this.logUserAction('Modification', 'Success', logDescription);
        this.showToast('The information was saved successfully', 'success');
        this.refreshIframe();
      } catch (error) {
        try {
          const apiUrl = process.env.VUE_APP_API_URL;
          if (this.playerCustomization.themeColor?.hex) {
            this.playerCustomization.themeColor = this.playerCustomization.themeColor?.hex;
          }
          await axios.put(
            `${apiUrl}/updatePlayerInfo/${this.planOdId}/${this.video.id}`,
            {
              allow_video_iframe: this.playerCustomization.privateVideo,
              allow_key_password: this.playerCustomization.allowKeyPassword,
              key_password: this.playerCustomization.keyPassword,
              video_360: this.playerCustomization.video360,
              load_after_play: this.playerCustomization.loadAfterPlay,
              allow_seo: this.playerCustomization.SEO,
              allow_progress: this.playerCustomization.progress,
              theme_color: this.playerCustomization.themeColor,
              allow_sharing: this.playerCustomization.sharing,
              allow_sharing_whatsapp: this.playerCustomization.whatsapp,
              allow_sharing_facebook: this.playerCustomization.facebook,
              allow_sharing_linkedin: this.playerCustomization.linkedin,
              allow_sharing_twitter: this.playerCustomization.twitter,
              auto_play: this.playerCustomization.autoplay,
              audio_notification_color: this.playerCustomization.audioNotificationColor,
              icon_text_color: this.playerCustomization.iconTextColor,
              big_button: this.playerCustomization.big_button,
            },
            {
              headers: {
                Authorization: `Bearer ${this.userToken}`,
              },
            },
          );
          let logDescription = `Alterou informações do vídeo ${this.oldVideo.name} com hash: ${this.oldVideo.hash} `;

          if (this.oldVideo.name !== this.video.name) {
            logDescription = `Vídeo com o hash: ${this.video.hash} teve o nome alterado de "${this.oldVideo.name}" para "${this.video.name}". `;
          }
          if (this.oldVideo.description !== this.video.description) {
            logDescription = `Vídeo com o hash: ${this.video.hash} teve a descrição alterada de "${this.oldVideo.description}" para "${this.video.description}". `;
          }
          if (this.oldVideo.cover !== this.video.cover) {
            logDescription = `Vídeo com o hash: ${this.video.hash} teve a capa alterada de "${this.oldVideo.cover}" para "${this.video.cover}". `;
          }
          if (this.oldVideo.parentId !== this.video.parentId) {
            logDescription = `Vídeo com o hash: ${this.video.hash} teve a pasta alterada de "${this.oldVideo.parentId}" para "${this.video.parentId}". `;
          }

          if (this.oldPlayerCustomization.autoplay !== this.playerCustomization.autoplay) {
            // eslint-disable-next-line max-len
            if (
              this.playerCustomization.autoplay === true
              || this.playerCustomization.autoplay === 1
            ) {
              logDescription = `Vídeo com o hash: ${this.video.hash} teve o auto play setado como true.`;
            } else {
              logDescription = `Vídeo com o hash: ${this.video.hash} teve o auto play setado como false.`;
            }
          }

          if (this.oldPlayerCustomization.big_button !== this.playerCustomization.big_button) {
            // eslint-disable-next-line max-len
            if (
              this.playerCustomization.big_button === true
              || this.playerCustomization.big_button === 1
            ) {
              logDescription = `Vídeo com o hash: ${this.video.hash} teve o big button setado como true.`;
            } else {
              logDescription = `Vídeo com o hash: ${this.video.hash} teve o big button setado como false.`;
            }
          }

          await this.logUserAction('Modification', 'Success', logDescription);
          this.showToast('The information was saved successfully on retry', 'success');
          this.refreshIframe();
        } catch (retryError) {
          this.showToast('Unable to perform this action, please try again later.', 'error');
        }
      }
    },
    async updateVideoInfoNoToast() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        if (this.playerCustomization.themeColor?.hex) {
          this.playerCustomization.themeColor = this.playerCustomization.themeColor?.hex;
        }
        await axios.put(
          `${apiUrl}/updatePlayerInfo/${this.planOdId}/${this.video.id}`,
          {
            allow_video_iframe: this.playerCustomization.privateVideo,
            allow_key_password: this.playerCustomization.allowKeyPassword,
            key_password: this.playerCustomization.keyPassword,
            video_360: this.playerCustomization.video360,
            load_after_play: this.playerCustomization.loadAfterPlay,
            allow_seo: this.playerCustomization.SEO,
            tags: this.playerCustomization.seoTags,
            allow_progress: this.playerCustomization.progress,
            theme_color: this.playerCustomization.themeColor,
            allow_sharing: this.playerCustomization.sharing,
            allow_sharing_whatsapp: this.playerCustomization.whatsapp,
            allow_sharing_facebook: this.playerCustomization.facebook,
            allow_sharing_linkedin: this.playerCustomization.linkedin,
            allow_sharing_twitter: this.playerCustomization.twitter,
            auto_play: this.playerCustomization.autoplay,
            audio_notification_color: this.playerCustomization.audioNotificationColor,
            icon_text_color: this.playerCustomization.iconTextColor,
            big_button: this.playerCustomization.big_button,
          },
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );

        let logDescription = `Alterou informações do vídeo ${this.oldVideo.name} com hash: ${this.oldVideo.hash} `;

        if (this.oldPlayerCustomization.autoplay !== this.playerCustomization.autoplay) {
          logDescription = `Vídeo com o hash: ${this.video.hash} teve o nome alterado de "${this.oldPlayerCustomization.autoplay}" para "${this.playerCustomization.autoplay}". `;
        }
        // eslint-disable-next-line max-len
        if (
          this.oldPlayerCustomization.audioNotificationColor
          !== this.playerCustomization.audioNotificationColor
        ) {
          logDescription = `Personalização de cores do botão central aplicada [primária: ${this.oldPlayerCustomization.audioNotificationColor}, secundária: ${this.oldPlayerCustomization.iconTextColor}] para o video com hash: ${this.video.hash}.`;
        }
        if (this.oldPlayerCustomization.iconTextColor !== this.playerCustomization.iconTextColor) {
          logDescription = `Personalização de cores do botão central aplicada [primária: ${this.oldPlayerCustomization.audioNotificationColor}, secundária: ${this.oldPlayerCustomization.iconTextColor}] para o video com hash: ${this.video.hash}.`;
        }

        await this.logUserAction('Modification', 'Success', logDescription);
        this.refreshIframe();
      } catch (error) {
        try {
          const apiUrl = process.env.VUE_APP_API_URL;
          if (this.playerCustomization.themeColor?.hex) {
            this.playerCustomization.themeColor = this.playerCustomization.themeColor?.hex;
          }
          await axios.put(
            `${apiUrl}/updatePlayerInfo/${this.planOdId}/${this.video.id}`,
            {
              allow_video_iframe: this.playerCustomization.privateVideo,
              allow_key_password: this.playerCustomization.allowKeyPassword,
              key_password: this.playerCustomization.keyPassword,
              video_360: this.playerCustomization.video360,
              load_after_play: this.playerCustomization.loadAfterPlay,
              allow_seo: this.playerCustomization.SEO,
              allow_progress: this.playerCustomization.progress,
              theme_color: this.playerCustomization.themeColor,
              allow_sharing: this.playerCustomization.sharing,
              allow_sharing_whatsapp: this.playerCustomization.whatsapp,
              allow_sharing_facebook: this.playerCustomization.facebook,
              allow_sharing_linkedin: this.playerCustomization.linkedin,
              allow_sharing_twitter: this.playerCustomization.twitter,
              auto_play: this.playerCustomization.autoplay,
              audio_notification_color: this.playerCustomization.audioNotificationColor,
              icon_text_color: this.playerCustomization.iconTextColor,
              big_button: this.playerCustomization.big_button,
            },
            {
              headers: {
                Authorization: `Bearer ${this.userToken}`,
              },
            },
          );

          let logDescription = `Alterou informações do vídeo ${this.oldVideo.name} com hash: ${this.oldVideo.hash} `;

          if (this.oldPlayerCustomization.autoplay !== this.playerCustomization.autoplay) {
            logDescription = `Vídeo com o hash: ${this.video.hash} teve o nome alterado de "${this.oldPlayerCustomization.autoplay}" para "${this.playerCustomization.autoplay}". `;
          }
          // eslint-disable-next-line max-len
          if (
            this.oldPlayerCustomization.audioNotificationColor
            !== this.playerCustomization.audioNotificationColor
          ) {
            logDescription = `Personalização de cores do botão central aplicada [primária: ${this.oldPlayerCustomization.audioNotificationColor}, secundária: ${this.oldPlayerCustomization.iconTextColor}] para o video com hash: ${this.video.hash}.`;
          }
          // eslint-disable-next-line max-len
          if (
            this.oldPlayerCustomization.iconTextColor !== this.playerCustomization.iconTextColor
          ) {
            logDescription = `Personalização de cores do botão central aplicada [primária: ${this.oldPlayerCustomization.audioNotificationColor}, secundária: ${this.oldPlayerCustomization.iconTextColor}] para o video com hash: ${this.video.hash}.`;
          }

          await this.logUserAction('Modification', 'Success', logDescription);
          this.refreshIframe();
        } catch (retryError) {
          this.showToast('Unable to perform this action, please try again later.', 'error');
          this.showToast('Unable to perform this action, please try again later.', 'error');
          const logDescription = `Erro ao tentar alterar informações do vídeo ${this.oldVideo.name} com hash: ${this.oldVideo.hash}`;
          await this.logUserAction('Modification', 'Error', logDescription);
          await this.logUserAction('Modification', 'Error', logDescription);
        }
      }
    },
    async fetchPlayerInfo() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/getPlayerInfo/${this.planOdId}/${this.video.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );

        const playerInfo = response.data.data;
        if (playerInfo.allow_video_iframe === true || playerInfo.allow_video_iframe === 1) {
          playerInfo.allow_video_iframe = false;
        } else {
          playerInfo.allow_video_iframe = true;
        }

        this.playerCustomization.privateVideo = playerInfo.allow_video_iframe;
        this.playerCustomization.allowKeyPassword = playerInfo.allow_key_password;
        this.playerCustomization.keyPassword = playerInfo.key_password;
        this.playerCustomization.video360 = playerInfo.video_360;
        this.playerCustomization.loadAfterPlay = playerInfo.load_after_play;
        this.playerCustomization.SEO = playerInfo.allow_seo;
        this.playerCustomization.seoTags = playerInfo.tags;
        this.availableTags = playerInfo.tags.map((tag: any) => ({ text: tag }));
        this.playerCustomization.progress = playerInfo.allow_progress;
        this.playerCustomization.themeColor = playerInfo.theme_color;
        this.playerCustomization.sharing = playerInfo.allow_sharing;
        this.playerCustomization.whatsapp = playerInfo.allow_sharing_whatsapp;
        this.playerCustomization.facebook = playerInfo.allow_sharing_facebook;
        this.playerCustomization.linkedin = playerInfo.allow_sharing_linkedin;
        this.playerCustomization.twitter = playerInfo.allow_sharing_twitter;
        this.playerCustomization.autoplay = playerInfo.auto_play;
        this.playerCustomization.audioNotificationColor = playerInfo.audio_notification_color;
        this.playerCustomization.iconTextColor = playerInfo.icon_text_color;
        this.playerCustomization.big_button = playerInfo.big_button;

        this.oldPlayerCustomization.privateVideo = playerInfo.allow_video_iframe;
        this.oldPlayerCustomization.allowKeyPassword = playerInfo.allow_key_password;
        this.oldPlayerCustomization.keyPassword = playerInfo.key_password;
        this.oldPlayerCustomization.video360 = playerInfo.video_360;
        this.oldPlayerCustomization.loadAfterPlay = playerInfo.load_after_play;
        this.oldPlayerCustomization.SEO = playerInfo.allow_seo;
        this.oldPlayerCustomization.seoTags = playerInfo.tags;
        this.availableTags = playerInfo.tags.map((tag: any) => ({ text: tag }));
        this.oldPlayerCustomization.progress = playerInfo.allow_progress;
        this.oldPlayerCustomization.themeColor = playerInfo.theme_color;
        this.oldPlayerCustomization.sharing = playerInfo.allow_sharing;
        this.oldPlayerCustomization.whatsapp = playerInfo.allow_sharing_whatsapp;
        this.oldPlayerCustomization.facebook = playerInfo.allow_sharing_facebook;
        this.oldPlayerCustomization.linkedin = playerInfo.allow_sharing_linkedin;
        this.oldPlayerCustomization.twitter = playerInfo.allow_sharing_twitter;
        this.oldPlayerCustomization.autoplay = playerInfo.auto_play;
        this.oldPlayerCustomization.audioNotificationColor = playerInfo.audio_notification_color;
        this.oldPlayerCustomization.iconTextColor = playerInfo.icon_text_color;
        this.oldPlayerCustomization.big_button = playerInfo.big_button;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },

    validateHexColor(colorType: 'audioNotificationColor' | 'iconTextColor') {
      const hexPattern = /^#([0-9A-F]{3}){1,2}$/i;
      if (hexPattern.test(this.playerCustomization[colorType])) {
        this.debouncedUpdateVideoInfo();
      }
    },
    generatePassword() {
      const length = 16;
      const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      let retVal = '';
      // eslint-disable-next-line no-plusplus
      for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      this.playerCustomization.keyPassword = retVal;
    },
    async uploadCover() {
      const $file = document.createElement('input') as any;
      $file.type = 'file';
      $file.accept = 'image/*';
      $file.classList.add('hidden');
      document.body.appendChild($file);

      $file.click();

      $file.addEventListener('change', async () => {
        try {
          if ($file.files.length === 0) {
            throw new Error('Nenhum arquivo selecionado');
          }

          const file = $file.files[0];
          const size = file.size / 1024 / 1024;

          if (size > 1) {
            this.showToast('File size exceeds the limit of 1MB. Please upload a smaller image.', 'error');
            throw new Error('O arquivo é muito grande. O arquivo precisa ter menos de 1 MB');
          }

          const formData = new FormData();
          formData.set('file', file);
          formData.set('noflow', '1');
          formData.set('APP', `OD-${this.planOdId}`);
          formData.set('videoHash', this.video.hash);
          formData.set('videoId', this.video.id);
          formData.set('type', 'OD_COVER');

          const apiUrl = process.env.VUE_APP_API_URL_STATIC;

          const uploadRequest = await fetch(`${apiUrl}/upload`, {
            method: 'POST',
            headers: {
              token: process.env.VUE_APP_API_URL_STATIC_TOKEN as string,
              createdate: process.env.VUE_APP_API_URL_STATIC_CREATEDATE as string,
            },
            body: formData,
          });

          const data = await uploadRequest.json();
          // eslint-disable-next-line prefer-destructuring
          this.video.cover = data.filename;
          await this.saveThumb();
          await this.thumbsUrl();
          this.thumbUpload = true;
          document.body.removeChild($file);

          const description = `Capa adicionada ao video ${this.video.name}, com hash ${this.video.hash}.`;
          await this.logUserAction('Modification', 'Success', description);
          this.showToast('Cover successfully added', 'success');
          this.refreshIframe();
        } catch (e) {
          console.error('Erro ao fazer upload da capa:', e);
          const description = `Erro ao adicionar capa ao video ${this.video.name}, com hash ${this.video.hash}.`;
          await this.logUserAction('Modification', 'Error', description);
          this.showToast('Error sending cover', 'error');
          document.body.removeChild($file);
        }
      });
    },
    async saveThumb() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        await axios.put(
          `${apiUrl}/updateVideo/${this.planOdId}/${this.video.id}`,
          {
            cover: this.video.cover,
            parentId: this.video.parentId,
          },
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );
      } catch (error) {
        console.error('Error saving video details:', error);
      }
    },
    thumbsUrl() {
      if (this.video.cover && this.video.cover.includes('/')) {
        if (this.video.storage_hash) {
          this.videoUrl1 = `${this.video.thumbBaseUrl}cover1.jpg?uf085lum5fbz=${this.video.storage_hash}`;
          this.videoUrl2 = `${this.video.thumbBaseUrl}cover2.jpg?uf085lum5fbz=${this.video.storage_hash}`;
          this.videoUrl3 = `${this.video.thumbBaseUrl}cover3.jpg?uf085lum5fbz=${this.video.storage_hash}`;
          this.coverSelect = `${this.video.thumbBaseUrl}${
            this.video.cover.split('/')[6]
          }?uf085lum5fbz=${this.video.storage_hash}`;
        } else {
          this.videoUrl1 = `${this.video.thumbBaseUrl}cover1.jpg`;
          this.videoUrl2 = `${this.video.thumbBaseUrl}cover2.jpg`;
          this.videoUrl3 = `${this.video.thumbBaseUrl}cover3.jpg`;
          this.coverSelect = `${this.video.thumbBaseUrl}${this.video.cover.split('/')[6]}`;
        }

        if (
          this.video.cover.split('/')[6] !== 'cover1.jpg'
          && this.video.cover.split('/')[6] !== 'cover2.jpg'
          && this.video.cover.split('/')[6] !== 'cover3.jpg'
        ) {
          this.thumbUpload = true;
        }
      } else if (this.video.cover) {
        if (this.video.storage_hash) {
          this.videoUrl1 = `${this.video.thumbBaseUrl}cover1.jpg?uf085lum5fbz=${this.video.storage_hash}`;
          this.videoUrl2 = `${this.video.thumbBaseUrl}cover2.jpg?uf085lum5fbz=${this.video.storage_hash}`;
          this.videoUrl3 = `${this.video.thumbBaseUrl}cover3.jpg?uf085lum5fbz=${this.video.storage_hash}`;
          this.coverSelect = `${this.video.thumbBaseUrl}${this.video.cover}?uf085lum5fbz=${this.video.storage_hash}`;
        } else {
          this.videoUrl1 = `${this.video.thumbBaseUrl}cover1.jpg`;
          this.videoUrl2 = `${this.video.thumbBaseUrl}cover2.jpg`;
          this.videoUrl3 = `${this.video.thumbBaseUrl}cover3.jpg`;
          this.coverSelect = `${this.video.thumbBaseUrl}${this.video.cover}`;
        }

        if (
          this.video.cover !== 'cover1.jpg'
          && this.video.cover !== 'cover2.jpg'
          && this.video.cover !== 'cover3.jpg'
        ) {
          this.thumbUpload = true;
        }
      }
    },
    async getCustomerPlan(id: string | number) {
      const response = await userService.getCustomerPlan(id);
      this.secretPlayer = response.data.data.secret;
      await this.loadVideoUrl();
    },
    copyLink() {
      navigator.clipboard.writeText(this.video.fileUrl).then(() => {
        this.showToast('link_copied', 'success');
      });
    },
    copyLinkCdn() {
      navigator.clipboard.writeText(this.video.cdnUrl).then(() => {
        this.showToast('link_copied', 'success');
      });
    },
    handlePlayerTypeChange() {
      if (this.player.type.value === 'fixed') {
        this.player.width = 640;
        this.player.height = 360;
      } else if (this.player.type.value === 'percentage') {
        this.player.width = 100;
        this.player.height = 100;
      } else {
        this.player.width = null;
        this.player.height = null;
      }
      this.generateIframeCode();
    },
    updateIframeCode() {
      const { fileUrl } = this.video;

      this.iframeCode = `<iframe allow="0" allowfullscreen class="jmvplayer" frameborder="0" src="${fileUrl}" width="${this.player.width}" height="${this.player.height}"></iframe>`;
    },
    generateIframeCode() {
      if (this.player.type.value === 'fixed' || this.player.type.value === 'percentage') {
        this.iframeCode = `<iframe allow="0" allowfullscreen class="jmvplayer" frameborder="0" src="${
          this.video.fileUrl
        }" width="${this.player.width}${
          this.player.type.value === 'percentage' ? '%' : ''
        }" height="${this.player.height}${
          this.player.type.value === 'percentage' ? '%' : ''
        }"></iframe>`;
      } else if (this.player.type.value === 'proportion') {
        this.iframeCode = ` <div class="jmvplayer" style="position: relative; padding-bottom: calc(100% / (16/9));"><iframe allow="autoplay; fullscreen;" allowfullscreen frameborder="0" src="${this.video.fileUrl}" style="position: absolute; height: 100%; width: 100%;"></iframe></div>`;
      } else if (this.player.type.value === 'proportion2') {
        this.iframeCode = ` <div class="jmvplayer" style="position: relative; padding-bottom: calc(100% / (4/3));"><iframe allow="autoplay; fullscreen;" allowfullscreen frameborder="0" src="${this.video.fileUrl}" style="position: absolute; height: 100%; width: 100%;"></iframe></div>`;
      }
    },
    copyIframeCode() {
      navigator.clipboard.writeText(this.iframeCode).then(() => {
        this.showToast('iframe_copied_successfully', 'success');
      });
    },
    async getBreadcrumb() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/breadcrumb/${this.planOdId}/${this.video.parentId}`,
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );

        this.breadcrumb = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    openSubtitleModal() {
      this.subtitleModal = true;
    },
    handleFileUpload(index: any, event: any) {
      this.$set(this.subtitleEntries[index], 'file', event);
    },
    addSubtitleEntry() {
      this.subtitleEntries.push({ language: null, file: null });
    },
    async uploadSubtitles() {
      const apiUrl = process.env.VUE_APP_API_URL_STATIC as any;
      const token = process.env.VUE_APP_API_URL_STATIC_TOKEN as any;
      const createdate = process.env.VUE_APP_API_URL_STATIC_CREATEDATE as any;

      try {
        // Converter a string de legendas (this.video.subtitle) em um array, se necessário
        let existingSubtitles = [];
        if (typeof this.video.subtitle === 'string') {
          existingSubtitles = JSON.parse(this.video.subtitle);
        }

        // Garantir que o array de legendas esteja inicializado
        if (!Array.isArray(existingSubtitles)) {
          existingSubtitles = [];
        }

        // eslint-disable-next-line no-restricted-syntax
        for (const entry of this.subtitleEntries as any) {
          const formData = new FormData();
          formData.set('file', entry.file);
          formData.set('noflow', '1');
          formData.set('APP', `OD-${this.planOdId}`);
          formData.set('videoHash', this.video.hash);
          formData.set('videoId', this.video.id);
          formData.set('type', 'OD_SUBTITLE');

          // eslint-disable-next-line no-await-in-loop
          const uploadRequest = await fetch(`${apiUrl}/upload`, {
            method: 'POST',
            headers: {
              token,
              createdate,
            },
            body: formData,
          });

          if (!uploadRequest.ok) {
            throw new Error(`Erro ao enviar legenda para ${entry.language}`);
          }

          // eslint-disable-next-line no-await-in-loop
          const data = await uploadRequest.json();

          // Verificar se a legenda com a mesma linguagem já existe
          // eslint-disable-next-line max-len
          const existingSubtitleIndex = existingSubtitles.findIndex(
            (subtitle) => subtitle.language === entry.language,
          );

          if (existingSubtitleIndex !== -1) {
            // Sobrescrever legenda existente
            existingSubtitles[existingSubtitleIndex] = {
              language: entry.language,
              name: entry.file.name,
              source: entry.file.name,
            };
          } else {
            // Adicionar nova legenda
            existingSubtitles.push({
              language: entry.language,
              name: entry.file.name,
              source: entry.file.name,
            });
          }

          const description = `Legenda adicionada ou atualizada ao video ${this.video.name}, com hash ${this.video.hash}.`;
          // eslint-disable-next-line no-await-in-loop
          await this.logUserAction('Creation', 'Success', description);
          this.showToast('Subtitles successfully added or updated', 'success');
        }

        // Atualizar `this.video.subtitle` (no singular) com o novo array de legendas
        this.video.subtitle = JSON.stringify(existingSubtitles);

        // Converter para salvar como `subtitles` (no plural)
        this.video.subtitles = this.video.subtitle;

        // Salvar as legendas atualizadas
        await this.saveSubtitle(this.video.subtitles);

        this.subtitleModal = false;
        this.video.subtitles = [];
        this.refreshIframe();
      } catch (error) {
        this.showToast('Error sending subtitles', 'error');
        const description = `Erro ao adicionar ou atualizar legenda ao video ${this.video.name}, com hash ${this.video.hash}.`;
        await this.logUserAction('Modification', 'Error', description);
        console.error('Erro ao enviar legendas:', error);
      }
    },

    async saveSubtitle(subtitlesString: any) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        await axios.put(
          `${apiUrl}/updateVideo/${this.planOdId}/${this.video.id}`,
          {
            subtitle: subtitlesString,
            parentId: this.video.parentId,
          },
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );
      } catch (error) {
        console.error('Error saving video details:', error);
      }
    },
    confirmDeleteSubtitle(index: any) {
      this.subtitleToDeleteIndex = index;
      this.deleteModalVisible = true;
    },
    async editSubtitle(index: any) {
      if (typeof this.video.subtitle === 'string') {
        this.video.subtitle = JSON.parse(this.video.subtitle);
      }
      const subtitleLanguage = this.video.subtitle[index].language;
      await this.$router.push({
        name: 'Transcription and Translation',
        params: { id: String(this.video.id), language: subtitleLanguage },
      });
    },
    async generateTranscription() {
      const subtitleLanguage = this.selectedLanguageTranscription;
      await this.$router.push({
        name: 'Transcription and Translation',
        params: { id: String(this.video.id), language: String(subtitleLanguage) },
      });
    },
    async deleteConfirmed() {
      if (this.subtitleToDeleteIndex !== null) {
        try {
          // Parse `this.video.subtitle` se for uma string JSON
          if (typeof this.video.subtitle === 'string') {
            this.video.subtitle = JSON.parse(this.video.subtitle);
          }

          if (Array.isArray(this.video.subtitle)) {
            const deletedSubtitle = JSON.parse(JSON.stringify(this.video.subtitle));

            const subtitle = deletedSubtitle.splice(this.subtitleToDeleteIndex, 1);

            const subtitlesString = JSON.stringify(subtitle);

            await this.saveSubtitle(subtitlesString);

            const deleteSub = (await this.deleteSubtitles(subtitlesString)) as any;

            if (deleteSub) {
              this.video.subtitle.splice(this.subtitleToDeleteIndex, 1);
            }

            // this.showToast('A legenda foi deletada com sucesso.', 'success');
          } else {
            console.error('Error: video.subtitle is not an array');
            // this.showToast('Erro ao deletar a legenda.', 'error');
          }
        } catch (error) {
          console.error('Erro ao deletar a legenda:', error);
          // this.showToast('Erro ao deletar a legenda.', 'error');
        } finally {
          this.deleteModalVisible = false;
          this.subtitleToDeleteIndex = null;
        }
      }
    },
    removeSubtitleEntry(index: any) {
      this.subtitleEntries.splice(index, 1);
    },
    async deleteSubtitles(subtitlesString: any) {
      if (subtitlesString) {
        // eslint-disable-next-line no-param-reassign
        subtitlesString = [];
      }
      try {
        const apiUrl = process.env.VUE_APP_API_URL_STATIC as string;
        const token = process.env.VUE_APP_API_URL_STATIC_TOKEN as string;
        const createdate = process.env.VUE_APP_API_URL_STATIC_CREATEDATE as string;
        await axios.delete(`${apiUrl}/subtitles/${this.planOdId}/${this.video.hash}`, {
          headers: {
            token,
            createdate,
          },
          data: subtitlesString,
        });
        await this.removeSubtitles();
        const description = `Legenda removida do video ${this.video.name}, com hash ${this.video.hash}.`;
        await this.logUserAction('Deletion', 'Success', description);
        this.deleteModalVisible = false;
        this.subtitleDeleteModal = false;
        this.showToast('Subtitles successfully deleted', 'success');
      } catch (error) {
        const description = `Erro ao remover legenda do video ${this.video.name}, com hash ${this.video.hash}.`;
        await this.logUserAction('Deletion', 'Error', description);
        this.showToast('Error deleting subtitles', 'error');
        console.error('Error deleting subtitles:', error);
      }
    },
    async removeSubtitles() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL as string;

        await axios.delete(`${apiUrl}/deleteSubtitle/${this.planOdId}/${this.video.id}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });
      } catch (error) {
        console.error('Error deleting subtitles:', error);
      }
    },
    async deleteVideo() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL as string;
        await axios.put(
          `${apiUrl}/removeFileOd/${this.planOdId}/${this.video.hash}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );
        this.showToast('Video successfully deleted', 'success');
        const description = `Vídeo ${this.video.name}, com hash ${this.video.hash} foi deletado com sucesso.`;
        await this.logUserAction('Deletion', 'Success', description);
        await this.$router.push({ name: 'Galleries' });
      } catch (error) {
        const description = `Erro ao deletar vídeo ${this.video.name}, com hash ${this.video.hash}.`;
        await this.logUserAction('Deletion', 'Error', description);
        this.showToast('Error deleting video', 'error');
        console.error('Error deleting video:', error);
      }
    },
    async applyDefault(event: any) {
      event.preventDefault();

      try {
        const apiUrl = process.env.VUE_APP_API_URL;

        await axios.put(
          `${apiUrl}/resetDefaultVideo/${this.planOdId}/${this.video.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );

        const description = `Resetou as informações do player do video ${this.video.name}, com hash ${this.video.hash} com sucesso.`;
        await this.logUserAction('Modification', 'Success', description);
        this.showToast('The information was saved successfully', 'success');
        this.refreshIframe();
        await this.fetchPlayerInfo();
      } catch (error) {
        try {
          const apiUrl = process.env.VUE_APP_API_URL;
          await axios.put(`${apiUrl}/resetDefaultVideo/${this.planOdId}/${this.video.id}`, {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          });

          const description = `Resetou as informações do player do video ${this.video.name}, com hash ${this.video.hash} com sucesso.`;
          await this.logUserAction('Modification', 'Success', description);
          this.showToast('The information was saved successfully', 'success');
          this.refreshIframe();
          await this.fetchPlayerInfo();
        } catch (retryError) {
          const description = `Erro ao resetar as informações do player do video ${this.video.name}, com hash ${this.video.hash}.`;
          await this.logUserAction('Modification', 'Error', description);
          this.showToast('Unable to perform this action, please try again later.', 'error');
        }
      }
    },
    formatHexColor(color: any): string {
      // Se for um objeto com propriedade hex, use essa propriedade
      if (color && typeof color === 'object' && color.hex) {
        // Remove o canal alpha (FF) se existir
        if (color.hex.length === 9) {
          return color.hex.substring(0, 7);
        }
        return color.hex;
      }

      // Se for uma string já formatada
      if (typeof color === 'string') {
        // Remove o canal alpha (FF) se existir
        if (color.length === 9 && color.startsWith('#')) {
          return color.substring(0, 7);
        }

        // Cores abreviadas como #F00 devem ser convertidas para #FF0000
        if (color.length === 4 && color.startsWith('#')) {
          const r = color.charAt(1);
          const g = color.charAt(2);
          const b = color.charAt(3);
          return `#${r}${r}${g}${g}${b}${b}`;
        }
      }

      // Retorna a cor como está ou uma cor padrão se for undefined
      return color || '#000000';
    },
  },
});
